// extracted by mini-css-extract-plugin
export var answertext = "FrequentQuestion-module--answertext--d8b6f";
export var frequentquestion = "FrequentQuestion-module--frequentquestion--22dca";
export var frequentquestionnospace = "FrequentQuestion-module--frequentquestionnospace--967a7 FrequentQuestion-module--frequentquestion--22dca";
export var questionheading = "FrequentQuestion-module--questionheading--055ea";
export var showmore = "FrequentQuestion-module--showmore--7b4fd";
export var visibilityhidden = "FrequentQuestion-module--visibilityhidden--23dbf";